import { render, staticRenderFns } from "./WorkshopFileStats.vue?vue&type=template&id=3fda0b42"
import script from "./WorkshopFileStats.vue?vue&type=script&lang=ts"
export * from "./WorkshopFileStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports